/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Performancetable_Collections_Topnewreleases3Inputs */

const id_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rilis Baru Teratas`)
};

const ms_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keluaran Baharu Teratas`)
};

const da_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top nye udgivelser`)
};

const de_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Neuerscheinungen`)
};

const en_us2_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top New Releases`)
};

const es_es2_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novedades destacadas`)
};

const es_mx2_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevos lanzamientos`)
};

const fil_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Pinakabagong Release`)
};

const fr_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meilleures nouvelles sorties`)
};

const it_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuove uscite migliori`)
};

const hu_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legjobb új megjelenések`)
};

const nl_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top nieuwe releases`)
};

const no_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topp nye utgivelser`)
};

const pl_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najlepsze nowości`)
};

const pt_br2_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principais novos lançamentos`)
};

const pt_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melhores novos lançamentos`)
};

const ro_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cele mai bune lansări noi`)
};

const fi_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parhaat uudet julkaisut`)
};

const sv_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topp nya släpp`)
};

const vi_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bản phát hành mới hàng đầu`)
};

const tr_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En İyi Yeni Çıkanlar`)
};

const cs_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejlepší nové vydání`)
};

const bg_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Топ нови издания`)
};

const ru_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лучшие новинки`)
};

const uk_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найкращі новинки`)
};

const ar_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أفضل الإصدارات الجديدة`)
};

const hi_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टॉप नए रिलीज़`)
};

const th_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกมใหม่ยอดนิยม`)
};

const ja_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注目の新作`)
};

const zh_cn2_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新发布`)
};

const zh_hant1_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新發布`)
};

const ko_components_performancetable_collections_topnewreleases3 = /** @type {(inputs: Components_Performancetable_Collections_Topnewreleases3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`신규 출시 상위`)
};

/**
* | output |
* | --- |
* | "Top New Releases" |
*
* @param {Components_Performancetable_Collections_Topnewreleases3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_performancetable_collections_topnewreleases3 = /** @type {((inputs?: Components_Performancetable_Collections_Topnewreleases3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Performancetable_Collections_Topnewreleases3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_performancetable_collections_topnewreleases3(inputs)
	if (locale === "ms") return ms_components_performancetable_collections_topnewreleases3(inputs)
	if (locale === "da") return da_components_performancetable_collections_topnewreleases3(inputs)
	if (locale === "de") return de_components_performancetable_collections_topnewreleases3(inputs)
	if (locale === "en-US") return en_us2_components_performancetable_collections_topnewreleases3(inputs)
	if (locale === "es-ES") return es_es2_components_performancetable_collections_topnewreleases3(inputs)
	if (locale === "es-MX") return es_mx2_components_performancetable_collections_topnewreleases3(inputs)
	if (locale === "fil") return fil_components_performancetable_collections_topnewreleases3(inputs)
	if (locale === "fr") return fr_components_performancetable_collections_topnewreleases3(inputs)
	if (locale === "it") return it_components_performancetable_collections_topnewreleases3(inputs)
	if (locale === "hu") return hu_components_performancetable_collections_topnewreleases3(inputs)
	if (locale === "nl") return nl_components_performancetable_collections_topnewreleases3(inputs)
	if (locale === "no") return no_components_performancetable_collections_topnewreleases3(inputs)
	if (locale === "pl") return pl_components_performancetable_collections_topnewreleases3(inputs)
	if (locale === "pt-BR") return pt_br2_components_performancetable_collections_topnewreleases3(inputs)
	if (locale === "pt") return pt_components_performancetable_collections_topnewreleases3(inputs)
	if (locale === "ro") return ro_components_performancetable_collections_topnewreleases3(inputs)
	if (locale === "fi") return fi_components_performancetable_collections_topnewreleases3(inputs)
	if (locale === "sv") return sv_components_performancetable_collections_topnewreleases3(inputs)
	if (locale === "vi") return vi_components_performancetable_collections_topnewreleases3(inputs)
	if (locale === "tr") return tr_components_performancetable_collections_topnewreleases3(inputs)
	if (locale === "cs") return cs_components_performancetable_collections_topnewreleases3(inputs)
	if (locale === "bg") return bg_components_performancetable_collections_topnewreleases3(inputs)
	if (locale === "ru") return ru_components_performancetable_collections_topnewreleases3(inputs)
	if (locale === "uk") return uk_components_performancetable_collections_topnewreleases3(inputs)
	if (locale === "ar") return ar_components_performancetable_collections_topnewreleases3(inputs)
	if (locale === "hi") return hi_components_performancetable_collections_topnewreleases3(inputs)
	if (locale === "th") return th_components_performancetable_collections_topnewreleases3(inputs)
	if (locale === "ja") return ja_components_performancetable_collections_topnewreleases3(inputs)
	if (locale === "zh-CN") return zh_cn2_components_performancetable_collections_topnewreleases3(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_performancetable_collections_topnewreleases3(inputs)
	return ko_components_performancetable_collections_topnewreleases3(inputs)
});
export { components_performancetable_collections_topnewreleases3 as "components.performanceTable.collections.topNewReleases" }